class CheckoutCompanySwitch {
  public items: HTMLCollection;
  public switch: any;
  public switch2: any;
  public visibleCheckbox: HTMLInputElement | null;
  public hiddenCheckbox: HTMLInputElement | null;

  bindings() {
    if (this.items) {
      Object.values(this.items).forEach((item: any) => {
        item.onclick = (item : any) => {
          this.removeActive();
          item.target.classList.add('is--active');
          if(item.target.dataset['id'] === "2"){
            this.switch.classList.toggle('d-none');
            this.switch2.classList.toggle('d-none');
          }
        }
      });
    }

    if (this.visibleCheckbox) {
      this.visibleCheckbox.addEventListener('change', () => {
        if (this.hiddenCheckbox) {
          this.hiddenCheckbox.value = this.visibleCheckbox?.checked ? '0' : '1';
        }
      });
    }
  }

  removeActive(){
    Object.values(this.items).forEach((item: any) => {
      item.classList.remove('is--active');
      this.switch.classList.add('d-none');
      this.switch2.classList.add('d-none');
    });
  }

  cache() {
    this.items = document.getElementsByClassName('js-company-switch');
    this.switch = document.getElementsByClassName('js-company-name')[0];
    this.switch2 = document.getElementsByClassName('js-company-tax-id')[0];
    this.visibleCheckbox = document.querySelector('#o-checkout__not-same-address');
    this.hiddenCheckbox = document.querySelector('.js-checkout__not-same-address');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default CheckoutCompanySwitch;
